export const cities = {
  islamabad: {
    slug: 'islamabad',
    name: 'Islamabad',
    title: 'Rent a Car in Islamabad | Amjed Tours',
    description: 'Rent premium cars in Islamabad from Amjed Tours. Toyota Prado, Land Cruiser V8, Revo, Honda Civic. Self-drive or with driver. Best rates in the capital.',
    heroSubtitle: 'From Faisal Mosque to the Margalla Hills — explore the capital in comfort',
    intro: 'Amjed Tours offers the largest fleet of premium rental cars in Islamabad. Whether you need a Toyota Prado for a family trip to Naran, a Land Cruiser V8 for a wedding, or a Honda Civic for business travel — we have you covered. Both self-drive and with-driver options available.',
    landmarks: ['Faisal Mosque', 'Daman-e-Koh', 'Pakistan Monument', 'Rawal Lake', 'Margalla Hills'],
    popularRoutes: ['Islamabad to Naran', 'Islamabad to Murree', 'Islamabad to Skardu', 'Islamabad to Hunza', 'Islamabad to Muzaffarabad'],
    keywords: 'rent a car Islamabad, car rental Islamabad, Toyota Prado rental Islamabad, self drive car Islamabad'
  },
  lahore: {
    slug: 'lahore',
    name: 'Lahore',
    title: 'Rent a Car in Lahore | Amjed Tours',
    description: 'Rent premium cars in Lahore. Toyota Corolla Grande, Prado, Land Cruiser V8. Self-drive or with driver. Affordable rates for Lahore rentals.',
    heroSubtitle: 'From Badshahi Mosque to Anarkali — discover Lahore your way',
    intro: 'Explore Lahore, the cultural heart of Pakistan, with a premium rental car from Amjed Tours. Perfect for weddings, business trips, and tours of historical sites. Our Corolla Grande and Prado are especially popular in Lahore.',
    landmarks: ['Badshahi Mosque', 'Lahore Fort', 'Shalimar Gardens', 'Minar-e-Pakistan', 'Anarkali Bazaar'],
    popularRoutes: ['Lahore to Multan', 'Lahore to Faisalabad', 'Lahore to Islamabad', 'Lahore to Sialkot', 'Lahore to Gujranwala'],
    keywords: 'rent a car Lahore, car rental Lahore, Toyota Corolla rental Lahore, wedding car Lahore'
  },
  karachi: {
    slug: 'karachi',
    name: 'Karachi',
    title: 'Rent a Car in Karachi | Amjed Tours',
    description: 'Rent premium cars in Karachi from Amjed Tours. Honda Civic, Toyota Corolla, Prado. Best car rental service in Karachi with self-drive and driver options.',
    heroSubtitle: 'From Clifton Beach to Do Darya — travel Karachi in style',
    intro: 'Amjed Tours provides top-tier car rental services across Karachi. Whether it is Honda Civic for city commutes, Land Cruiser V8 for VIP travel, or Prado for family outings — we have Pakistan\'s largest business city covered.',
    landmarks: ['Clifton Beach', 'Mazar-e-Quaid', 'Port Grand', 'Do Darya', 'Frere Hall'],
    popularRoutes: ['Karachi to Hyderabad', 'Karachi to Thatta', 'Karachi to Gwadar', 'Karachi to Sukkur', 'Karachi to Larkana'],
    keywords: 'rent a car Karachi, car rental Karachi, Honda Civic rental Karachi, luxury car Karachi'
  },
  peshawar: {
    slug: 'peshawar',
    name: 'Peshawar',
    title: 'Rent a Car in Peshawar | Amjed Tours',
    description: 'Rent premium cars in Peshawar. Toyota Hilux Revo, Prado, Land Cruiser V8. Ideal for northern areas trips. Book online with Amjed Tours.',
    heroSubtitle: 'Gateway to the Khyber Pass and Northern Pakistan',
    intro: 'Peshawar is your gateway to the majestic north. Rent our Hilux Revo or Prado for adventures through Swat, Chitral, and Kalash Valley. All-wheel drive options perfect for mountain terrain.',
    landmarks: ['Bala Hisar Fort', 'Qissa Khwani Bazaar', 'Peshawar Museum', 'Sethi House', 'Mahabat Khan Mosque'],
    popularRoutes: ['Peshawar to Swat', 'Peshawar to Chitral', 'Peshawar to Kalash', 'Peshawar to Naran', 'Peshawar to Islamabad'],
    keywords: 'rent a car Peshawar, car rental Peshawar, Hilux Revo Peshawar, Swat trip car rental'
  }
};

export const citySlugs = Object.keys(cities);
